import React from "react";

import Image     from "_components/atoms/image";
import useStyles from "_styles/molecules/imageComponent";

const component =  props => {
	const {
		bottomLeftFlag,
		bottomRightFlag,
		topLeftFlag,
		topRightFlag,
		image,
		handleImageModalOpen,
		setImageForModal
	} = props;
	const { classes } = useStyles ( { bottomLeftFlag, bottomRightFlag, topLeftFlag, topRightFlag } );

	return (
		<div className = { classes.imageContainer }>
			<Image
				className = { classes.imageStyles }
				onClick = { () => {
					handleImageModalOpen ();
					setImageForModal ();
				} }
				src = { image.media[0].href }
			/>
		</div>

	);
};

export default component;
